import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * Vertical Lane in the overview ruler of the editor.
 */
export var OverviewRulerLane;

(function (OverviewRulerLane) {
  OverviewRulerLane[OverviewRulerLane["Left"] = 1] = "Left";
  OverviewRulerLane[OverviewRulerLane["Center"] = 2] = "Center";
  OverviewRulerLane[OverviewRulerLane["Right"] = 4] = "Right";
  OverviewRulerLane[OverviewRulerLane["Full"] = 7] = "Full";
})(OverviewRulerLane || (OverviewRulerLane = {}));
/**
 * Position in the minimap to render the decoration.
 */


export var MinimapPosition;

(function (MinimapPosition) {
  MinimapPosition[MinimapPosition["Inline"] = 1] = "Inline";
  MinimapPosition[MinimapPosition["Gutter"] = 2] = "Gutter";
})(MinimapPosition || (MinimapPosition = {}));

export var TextModelResolvedOptions = /*#__PURE__*/function () {
  /**
   * @internal
   */
  function TextModelResolvedOptions(src) {
    _classCallCheck(this, TextModelResolvedOptions);

    this.tabSize = Math.max(1, src.tabSize | 0);
    this.indentSize = src.tabSize | 0;
    this.insertSpaces = Boolean(src.insertSpaces);
    this.defaultEOL = src.defaultEOL | 0;
    this.trimAutoWhitespace = Boolean(src.trimAutoWhitespace);
  }
  /**
   * @internal
   */


  _createClass(TextModelResolvedOptions, [{
    key: "equals",
    value: function equals(other) {
      return this.tabSize === other.tabSize && this.indentSize === other.indentSize && this.insertSpaces === other.insertSpaces && this.defaultEOL === other.defaultEOL && this.trimAutoWhitespace === other.trimAutoWhitespace;
    }
    /**
     * @internal
     */

  }, {
    key: "createChangeEvent",
    value: function createChangeEvent(newOpts) {
      return {
        tabSize: this.tabSize !== newOpts.tabSize,
        indentSize: this.indentSize !== newOpts.indentSize,
        insertSpaces: this.insertSpaces !== newOpts.insertSpaces,
        trimAutoWhitespace: this.trimAutoWhitespace !== newOpts.trimAutoWhitespace
      };
    }
  }]);

  return TextModelResolvedOptions;
}();
export var FindMatch =
/**
 * @internal
 */
function FindMatch(range, matches) {
  _classCallCheck(this, FindMatch);

  this.range = range;
  this.matches = matches;
};
/**
 * @internal
 */

export var ValidAnnotatedEditOperation = function ValidAnnotatedEditOperation(identifier, range, text, forceMoveMarkers, isAutoWhitespaceEdit, _isTracked) {
  _classCallCheck(this, ValidAnnotatedEditOperation);

  this.identifier = identifier;
  this.range = range;
  this.text = text;
  this.forceMoveMarkers = forceMoveMarkers;
  this.isAutoWhitespaceEdit = isAutoWhitespaceEdit;
  this._isTracked = _isTracked;
};
/**
 * @internal
 */

export var ApplyEditsResult = function ApplyEditsResult(reverseEdits, changes, trimAutoWhitespaceLineNumbers) {
  _classCallCheck(this, ApplyEditsResult);

  this.reverseEdits = reverseEdits;
  this.changes = changes;
  this.trimAutoWhitespaceLineNumbers = trimAutoWhitespaceLineNumbers;
};